import WasmController from "react-lib/frameworks/WasmController";
import { State as MainState } from "react-lib/apps/segment/SegmentInterface";

// APIs
import {
  ListDataType,
  RuleTemplatesType,
  SegmentItem,
  PostItem,
  ListSegmentTreesType,
  SegmentData,
  typeAction,
  DataRuleTemplatesType,
  RawDataRuleTemplatesType,
  RawDataListType,
  SegmentRule,
} from "react-lib/apps/segment/segmentTreeType";
import {
  Timestamp,
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
  getDoc,
  serverTimestamp,
  updateDoc,
  deleteDoc,
  deleteField,
  runTransaction,
  getDocFromServer,
  onSnapshot,
  increment,
} from "firebase/firestore";
import { getStorage, ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { getApp } from "firebase/app";

import * as XLSX from "xlsx";

import CONFIG from "config/config";

export type State = {
  SegmentTargetSequence: {
    sequenceIndex?: string | null;
    organsMaster: any[];
    loadingSegmentList?: boolean;
    listSegmentTrees?: ListSegmentTreesType[];
    ruleTemplates?: RuleTemplatesType[];
    listSegments?: SegmentItem[];
    contentList?: PostItem[];
    selectedSegmentId?: string;
    selectedSegmentTreeId?: string;
    organTips?: any[];
    posts?: any[];
    error?: any;
    loading?: boolean;
    idxPublishLoading?: string;
    idxUnpublishLoading?: string;
    idxSaveLoading?: string;
    ruleFile?: File;
    loadingStatus?: Record<string, any>;
  } | null;
};

export const StateInitial: State = {
  SegmentTargetSequence: {
    sequenceIndex: null,
    organsMaster: [],
    loadingSegmentList: false,
    listSegmentTrees: [],
    ruleTemplates: [],
    listSegments: [],
    selectedSegmentId: "",
    selectedSegmentTreeId: "",
    organTips: [],
    posts: [],
    loading: false,
    idxPublishLoading: "",
    idxUnpublishLoading: "",
    idxSaveLoading: "",
    ruleFile: undefined,
    loadingStatus: undefined,
  },
};

export type Props = {};

export type Event =
  | { message: "RunSequence"; params: {} }
  | { message: "GetMasterData"; params: {} };

export type Data = {
  division?: number;
};

type Picked = Partial<
  Pick<
    MainState,
    "buttonLoadCheck" | "errorMessage" | "successMessage" | "masterOptions" | "django" | "userId"
  >
>;

export const DataInitial = {};

type Handler<P = any, R = any> = (
  controller: WasmController<State & Picked, Event, Data, Props>,
  params: P,
) => R;

/********************************************
 *
 *
 *  Constant
 *
 *
 *******************************************/

export const PREFIX = "mehealth_";
export const SEGMENT_TREE = `${PREFIX}segmentTrees`;
export const SEGMENT = `${PREFIX}segments`;
export const RULE_TEMPLATES = `${PREFIX}ruleTemplates`;
export const POST = `${PREFIX}posts`;
export const ORGAN_TIPS = `${PREFIX}organTips`;
export const SEGMWENT_RULE_TEMPLATES = `segment_ruleTemplates`;

export const MEDICAL_REPORT_GS =
  CONFIG.FIREBASE_PROJECT === "mehealthportal"
    ? "gs://medical-reports-storage-prod"
    : "gs://medical-reports-storage";
export const MEHEALTH_POST_GS =
  CONFIG.FIREBASE_PROJECT === "mehealthportal" ? "gs://mehealth-post-prod" : "gs://mehealth-post";

export const Start: Handler = async (controller, params) => {
  // const querySnapshot = await getDocs(collection(controller.db, SEGMENT_TREE));
  // const listSegmentTrees: ListSegmentTreesType[] = [];
  // querySnapshot.forEach((doc: any) => {
  //   listSegmentTrees.push({ id: doc.id, data: doc.data() });
  // });
  const listSegmentTrees = await getSegmentTree(controller);
  let organsMaster: any = [];
  const queryRuleTemplates = await getDocs(collection(controller.db, RULE_TEMPLATES));
  const ruleTemplates: RuleTemplatesType[] = [];
  queryRuleTemplates.forEach((doc: any) => {
    ruleTemplates.push({ id: doc.id, data: doc.data() });
  });

  let response = await fetch(`${CONFIG.FAST_API}/api/v1/feed/organs-dropdown`, {
    method: "GET",
    headers: {
      Authorization: `Token ${controller.apiToken}`,
      "Content-Type": "application/json",
      accept: "application/json",
    },
  });

  console.log("START response: ", response);
  if (response.status === 200) {
    organsMaster = await (await response.blob()).text();
    organsMaster = JSON.parse(organsMaster);
    if (organsMaster?.success) {
      organsMaster = organsMaster?.data;
    }
    console.log("organMaster: ", organsMaster);
  }

  controller.setState(
    {
      SegmentTargetSequence: {
        sequenceIndex: "Action",
        organsMaster: organsMaster,
        listSegmentTrees: listSegmentTrees,
        ruleTemplates: ruleTemplates,
        selectedSegmentId: "",
      },
    },
    () => {
      controller.handleEvent({ message: "RunSequence", params: { ...params } });
    },
  );
};

export const Action: Handler = async (controller, params) => {
  console.log("Action ", params.action, ": params  ->", params);

  if (params.action === "QueryTreesSegment") {
    QueryTreesSegment(controller, params);
  } else if (params.action === "querySegmentFromSegmentTreesId") {
    QuerySegmentFromSegmentTreesId(controller, params);
  } else if (params.action === "NewTreeSegment") {
    NewTreeSegment(controller, params);
  } else if (params.action === "EditNameTreeSegment") {
    EditNameTreeSegment(controller, params);
  } else if (params.action === "AddSegment") {
    AddSegment(controller, params);
  } else if (params.action === "DeleteAllChildSegment") {
    DeleteAllChildSegment(controller, params);
  } else if (params.action === "AddContent") {
    AddContent(controller, params);
  } else if (params.action === "SelectSegment") {
    SelectSegment(controller, params);
  } else if (params.action === "UpdateContents") {
    return UpdateContents(controller, params);
  } else if (params.action === "SaveContent") {
    SaveContent(controller, params);
  } else if (params.action === "DeleteContent") {
    DeleteContent(controller, params);
  } else if (params.action === "Publish") {
    return Publish(controller, params);
  } else if (params.action === "UnPublish") {
    return UnPublish(controller, params);
  } else if (params.action === "GetPublicContents") {
    return GetPublicContents(controller, params);
  } else if (params.action === "ImportRule") {
    return ImplementRuleFile(controller, params);
  }
};

/******************************************************************************************
 *
 *  Firebase
 *
 * ***************************************************************************************/

const getSegmentTree = async (controller: any) => {
  const querySnapshot = await getDocs(collection(controller.db, SEGMENT_TREE));
  let listSegmentTrees: ListSegmentTreesType[] = [];
  querySnapshot.forEach((doc: any) => {
    listSegmentTrees.push({ id: doc.id, data: doc.data() });
  });
  console.log("getSegmentTree listSegmentTrees: ", listSegmentTrees);
  let state = controller.getState();
  console.log("getSegmentTree state: ", state);
  listSegmentTrees = listSegmentTrees.filter(
    (i) =>
      i.data.divisionId === state.selectedDivision?.id ||
      i.data.created_by === Number(state.userId),
  );
  console.log("getSegmentTree listSegmentTrees: ", listSegmentTrees);
  return listSegmentTrees;
};

const getRawDataRuleTemplates = async (controller: any) => {
  const querySnapshot = await getDocs(collection(controller.db, SEGMWENT_RULE_TEMPLATES));
  let rawDataRuleTemplatesList: RawDataListType[] = [];
  querySnapshot.forEach((doc: any) => {
    rawDataRuleTemplatesList.push({ id: doc.id, data: doc.data() });
  });
  let state = controller.getState();

  return rawDataRuleTemplatesList;
};

const getSegmentFromTreeId = async (db, segmentTreeId) => {
  const segmentItem: SegmentItem[] = [];
  const querySegments = query(
    collection(db, SEGMENT),
    where("segment_tree_id", "==", segmentTreeId),
  );
  console.log("querySegments:", querySegments);
  const querySnapshot = await getDocs(querySegments);

  querySnapshot.forEach((doc: any) => {
    segmentItem.push({ id: doc.id, data: doc.data() });
  });

  return segmentItem;
};

const getAttachedPost = async (db, currentSegment) => {
  let attached_posts = currentSegment?.data?.attached_posts ?? [];

  let posts: any[] = [];
  if (attached_posts?.length > 0) {
    const results = await Promise.all(
      attached_posts.map((documentId: string) => getDoc(doc(db, POST, documentId))),
    );
    console.log("results: ", results);
    posts = results
      .map((i) => i.data())
      .filter(Boolean)
      .filter((i) => i.is_active);
  }

  return posts;
};

const getAttachedOrganTips = async (db, currentSegment) => {
  let attached_organTips = currentSegment?.data?.attached_organTips ?? [];

  let organTips: any[] = [];
  if (attached_organTips?.length > 0) {
    const results = await Promise.all(
      attached_organTips.map((documentId: string) => getDoc(doc(db, ORGAN_TIPS, documentId))),
    );
    console.log("results: ", results);
    organTips = results
      .map((i) => i.data())
      .filter(Boolean)
      .filter((i) => i.is_active);
  }

  return organTips;
};

const getContentsRelated = async (db, currentSegment) => {
  console.log("currentSegment: ", currentSegment);
  let posts = await getAttachedPost(db, currentSegment);
  let organTips = await getAttachedOrganTips(db, currentSegment);

  console.log("currentSegment [posts, organTips]: ", posts, organTips);
  return [posts, organTips];
};

/******************************************************************************************
 *
 *
 *  Handler
 *
 * ***************************************************************************************/

const QueryTreesSegment: Handler = async (controller, params) => {
  let listSegmentTrees: ListSegmentTreesType[] = await getSegmentTree(controller);
  let state = controller.getState();
  console.log("QueryTreesSegment listSegmentTrees: ", listSegmentTrees);
  console.log("QueryTreesSegment listTrees: ", listSegmentTrees);
  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      sequenceIndex: "Action",
      listSegmentTrees: listSegmentTrees,
    },
  });
};

const QuerySegmentFromSegmentTreesId: Handler = async (controller, params) => {
  try {
    const listSegmentTrees: ListSegmentTreesType[] = await getSegmentTree(controller);
    const listSegments: SegmentItem[] = await getSegmentFromTreeId(controller.db, params.id);
    let state = controller.getState();

    console.log("querySegment: listSegments ", listSegments);
    console.log("querySegment: listSegmentTrees ", listSegmentTrees);

    state = controller.getState();
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        listSegments: listSegments,
        listSegmentTrees: listSegmentTrees,
        selectedSegmentId: "",
        selectedSegmentTreeId: params.id,
      },
    });
  } catch (error) {
    console.log("Debug ~ error querySegment collection :", error);
  }
};

const NewTreeSegment: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      loading: true,
    },
  });

  const dataTemplate: ListDataType = {
    created_at: serverTimestamp(),
    created_by: Number(state.userId),
    description: params.description,
    divisionCode: state.selectedDivision?.code,
    divisionId: state.selectedDivision?.id,
    is_active: true,
    name: params.name,
    root_segment_id: [],
    updated_at: serverTimestamp(),
  };
  console.log("Debug ~ dateTemplate:", dataTemplate);

  await addDoc(collection(controller.db, SEGMENT_TREE), dataTemplate)
    .then(async () => {
      console.log("Debug ~ Document successfully written!");
      const listSegmentTrees: ListSegmentTreesType[] = await getSegmentTree(controller);
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          listSegmentTrees,
          loading: false,
        },
      });
    })
    .catch((error) => {
      console.error("Debug ~ Error writing document: ", error);
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          loading: false,
        },
      });
    });
};

const EditNameTreeSegment: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      loading: true,
    },
  });

  await updateDoc(doc(controller.db, SEGMENT_TREE, params.id), {
    name: params.name,
    description: params.description,
    updated_at: serverTimestamp(),
  })
    .then(async () => {
      console.log("Document successfully update!");
      const listSegmentTrees: ListSegmentTreesType[] = await getSegmentTree(controller);
      const listSegments: SegmentItem[] = await getSegmentFromTreeId(controller.db, params.id);
      state = controller.getState();
      // await querySegment(controller, {id: params.id})
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          listSegments: listSegments,
          listSegmentTrees: listSegmentTrees,
          loading: false,
        },
      });
    })
    .catch((error) => {
      console.error("Error writing document: ", error);
      state = controller.getState();
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          loading: false,
        },
      });
    });
};

const AddSegment: Handler = async (controller, params) => {
  let state = controller.getState();
  console.log("addSegment state: ", state.SegmentTargetSequence);
  console.log("addSegment params: ", params);
  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      loading: true,
    },
  });

  // Find RuleTemplate

  const ruleTemplate = state.SegmentTargetSequence?.ruleTemplates?.find(
    (i) => i.id === params.ruleTemplateId,
  )?.data;
  const isFirst = state.SegmentTargetSequence?.listSegmentTrees?.find(
    (i) => i.id === params.parentId,
  );

  let path_from_root: any[] = [];
  let segment_tree_id = "";
  let parent_segment_id = "";
  if (isFirst) {
    path_from_root = [];
    segment_tree_id = params.parentId;
    parent_segment_id = "";
  }

  let currentSex = "";
  let currentAge: any = null;
  if (!isFirst) {
    let parentSegment = state.SegmentTargetSequence?.listSegments?.find(
      (i) => i.id === params.parentId,
    );
    segment_tree_id = String(parentSegment?.data?.segment_tree_id);
    path_from_root = [...(parentSegment?.data?.path_from_root ?? []), params.parentId];
    parent_segment_id = params.parentId; /// ถ้าเป็นภายใน segment หาแบบนึง แต่ถ้าเป็นตัวแรก เป็นค่าว่าง

    const parentSegments = state.SegmentTargetSequence?.listSegments?.filter(
      (s) => path_from_root.includes(s.id) || s.id === params.parentId,
    );
    const sexSegment = parentSegments?.find((s) => s.data?.rule?.field === "sex");
    if (sexSegment) {
      currentSex = String(sexSegment.data?.rule?.value).toLowerCase();
    }
    const ageSegment = parentSegments?.find((s) => s.data?.rule?.field === "age");
    if (ageSegment) {
      currentAge = ageSegment.data?.rule ?? null;
    }
  }

  const options = ruleTemplate?.template?.condition_options || [];
  const requiredSexes = Array.from(
    new Set(options.map((o) => String(o.sex || "all").toLowerCase())),
  ).filter((s) => s !== "all");

  // Helper: parse optAge string → structured rule
  const parseOptAge = (optAge: string) => {
    if (!optAge || optAge === "All") return null;
    const rangeMatch = optAge.match(/(\d+)\s*[-–]\s*(\d+)/);
    if (rangeMatch)
      return { operator: "range", min: Number(rangeMatch[1]), max: Number(rangeMatch[2]) };
    const opMatch = optAge.match(/^(<=|>=|<|>)\s*(\d+)/);
    if (opMatch) return { operator: opMatch[1], value: Number(opMatch[2]) };
    const numMatch = optAge.match(/(\d+)/);
    if (numMatch) return { operator: "==", value: Number(numMatch[0]) };
    return null;
  };

  const normalizeOp = (op: string) =>
    op === "<" || op === "<=" ? "<" : op === ">" || op === ">=" ? ">" : op;

  // Helper: filter condition options by currentAge
  const filterByAge = (opts: any[]): any[] => {
    if (!currentAge) return opts;
    return opts.filter((opt) => {
      const optAge = String(opt.age || "All");
      if (optAge === "All") return true;
      const parsed = parseOptAge(optAge);
      if (!parsed) return false;
      if (parsed.operator === "range" && currentAge.operator === "range") {
        return parsed.min === currentAge.min_value && parsed.max === currentAge.max_value;
      }
      return (
        normalizeOp(parsed.operator) === normalizeOp(currentAge.operator) &&
        parsed.value === currentAge.value
      );
    });
  };

  // master_data_ids from the selected ruleTemplate to stamp on each lab segment
  const templateMasterDataIds: string[] = ruleTemplate?.master_data_ids ?? [];

  const createSegment = async (opt: any, index: number, parentId: string, path: string[]) => {
    const segment = createSegmentData({
      name: opt?.text || "",
      description: params.description,
      seq: index,
      rule: createRuleData(ruleTemplate, opt),
      segment_tree_id,
      parent_segment_id: parentId,
      path_from_root: path,
      created_by: Number(state.userId),
      master_data_ids: templateMasterDataIds,
    });
    const docRef = await addDoc(collection(controller.db, SEGMENT), segment);

    const target_organs = getTargetOrgans(opt?.target_organ);
    if (target_organs.length > 0) {
      await upsertOrganTipsForSegment(
        controller,
        state,
        docRef.id,
        opt?.personalized_advice ?? "",
        target_organs,
      );
    }

    return docRef;
  };

  try {
    if (!currentSex && requiredSexes.length > 0) {
      // Create sex segments first, then lab segments under them
      const sexRuleTemplate = state.SegmentTargetSequence?.ruleTemplates?.find(
        (i) => i.data?.field === "sex",
      )?.data;

      for (let i = 0; i < requiredSexes.length; i++) {
        const reqSex = requiredSexes[i];
        const sexOption = sexRuleTemplate?.template?.condition_options?.find(
          (o) => String(o.value).toLowerCase() === reqSex,
        );

        const sexSegmentData = createSegmentData({
          name: sexOption ? sexOption.text : reqSex === "male" ? "เพศชาย" : "เพศหญิง",
          seq: i,
          rule: {
            rule_type: "demographic",
            field: "sex",
            value: sexOption ? sexOption.value : reqSex === "male" ? "Male" : "Female",
          },
          segment_tree_id,
          parent_segment_id,
          path_from_root,
          created_by: Number(state.userId),
        });

        const sexDocRef = await addDoc(collection(controller.db, SEGMENT), sexSegmentData);
        const newParentId = sexDocRef.id;
        const newPath = [...path_from_root, newParentId];

        const labOptions = filterByAge(
          options.filter((opt) => {
            const optSex = String(opt.sex || "all").toLowerCase();
            return optSex === "all" || optSex === reqSex;
          }),
        );

        for (let j = 0; j < labOptions.length; j++) {
          await createSegment(labOptions[j], j, newParentId, newPath);
        }
      }
    } else {
      // Sex is already specified or not required, just create normally
      let filteredOptions = filterByAge(options);
      if (currentSex) {
        filteredOptions = filteredOptions.filter((opt) => {
          const optSex = String(opt.sex || "all").toLowerCase();
          return optSex === "all" || optSex === currentSex;
        });
      }

      for (let index = 0; index < filteredOptions.length; index++) {
        await createSegment(filteredOptions[index], index, parent_segment_id, path_from_root);
      }
    }

    console.log("Debug ~ Documents successfully written!");
    const listSegments: SegmentItem[] = await getSegmentFromTreeId(controller.db, segment_tree_id);

    // Update SegmentTree: root_segment_id and master_data_ids
    const rootSegmentIds = listSegments
      .filter((s) => s.data.parent_segment_id === "")
      .map((s) => s.id);

    const existingTree = state.SegmentTargetSequence?.listSegmentTrees?.find(
      (t) => t.id === segment_tree_id,
    );

    // Merge master_data_ids from the selected ruleTemplate (unique)
    const incomingMasterDataIds: string[] = ruleTemplate?.master_data_ids ?? [];
    const existingMasterDataIds: string[] = existingTree?.data?.master_data_ids ?? [];
    const mergedMasterDataIds: string[] = Array.from(
      new Set([...existingMasterDataIds, ...incomingMasterDataIds]),
    );

    await updateDoc(doc(controller.db, SEGMENT_TREE, segment_tree_id), {
      root_segment_id: rootSegmentIds,
      ...(mergedMasterDataIds.length > 0 && { master_data_ids: mergedMasterDataIds }),
      updated_at: serverTimestamp(),
    });

    const listSegmentTrees: ListSegmentTreesType[] = await getSegmentTree(controller);
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        listSegments,
        listSegmentTrees,
        loading: false,
      },
    });
  } catch (error) {
    console.error("Debug ~ Error writing documents: ", error);
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        loading: false,
      },
    });
  }
};

const DeleteAllChildSegment: Handler = async (controller, params) => {
  let state = controller.getState();
  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      loading: true,
    },
  });

  const isFirst = state.SegmentTargetSequence?.listSegmentTrees?.find(
    (i) => i.id === params.parentId,
  );

  const segmentCollectionRef = collection(controller.db, SEGMENT);
  const deletePromises: any[] = [];

  // Create a query against the collection.
  let key = isFirst ? "segment_tree_id" : "parent_segment_id";
  let segment_tree_id = isFirst
    ? params.parentId
    : state.SegmentTargetSequence?.listSegments?.find((i) => i.id === params.parentId)?.data
      ?.segment_tree_id;

  // --- PRE-DELETE CHECK ---
  // Fetch all segments in this tree BEFORE deletion to determine which master_data_ids are safe to remove

  // 1. Get the to-be-deleted segment IDs from the query
  const deleteQuery = await query(segmentCollectionRef, where(key, "==", params.parentId));
  const snapshot = await getDocs(deleteQuery);

  const deletedSegmentIds = new Set<string>();
  const masterDataIdsOfDeleted = new Set<string>();

  snapshot.forEach((docSnap) => {
    deletedSegmentIds.add(docSnap.id);
    const ids: string[] = docSnap.data()?.master_data_ids ?? [];
    ids.forEach((id) => masterDataIdsOfDeleted.add(id));
  });

  // 2. Get all segments in the tree (from local state — already loaded)
  const allTreeSegments = (state.SegmentTargetSequence?.listSegments ?? []).filter(
    (s) => s.data.segment_tree_id === segment_tree_id,
  );

  // 3. Segments that WILL SURVIVE (not in deletedSegmentIds)
  const survivingSegments = allTreeSegments.filter((s) => !deletedSegmentIds.has(s.id));

  // 4. master_data_ids still referenced by surviving segments
  const masterDataIdsOfSurvivors = new Set<string>(
    survivingSegments.flatMap((s) => s.data?.master_data_ids ?? []),
  );

  // 5. IDs to remove = in deleted set AND not referenced by any survivor
  const idsToRemoveFromTree = Array.from(masterDataIdsOfDeleted).filter(
    (id) => !masterDataIdsOfSurvivors.has(id),
  );

  console.log("DeleteAllChildSegment — pre-check:", {
    deletedSegmentIds: Array.from(deletedSegmentIds),
    masterDataIdsOfDeleted: Array.from(masterDataIdsOfDeleted),
    masterDataIdsOfSurvivors: Array.from(masterDataIdsOfSurvivors),
    idsToRemoveFromTree,
  });
  // --- END PRE-DELETE CHECK ---

  snapshot.forEach((doc) => {
    deletePromises.push(deleteDoc(doc.ref));
  });

  await Promise.all(deletePromises)
    .then(async () => {
      console.log("Document successfully update!");
      const listSegments: SegmentItem[] = await getSegmentFromTreeId(
        controller.db,
        segment_tree_id,
      );

      // Recalculate root_segment_id after deletion
      const rootSegmentIds = listSegments
        .filter((s) => s.data.parent_segment_id === "")
        .map((s) => s.id);

      // Compute updated master_data_ids for the tree:
      // Start from current tree's master_data_ids, remove only the ones that are safe to remove
      const existingTree = state.SegmentTargetSequence?.listSegmentTrees?.find(
        (t) => t.id === segment_tree_id,
      );
      const currentTreeMasterDataIds: string[] = existingTree?.data?.master_data_ids ?? [];
      const updatedMasterDataIds = currentTreeMasterDataIds.filter(
        (id) => !idsToRemoveFromTree.includes(id),
      );

      await updateDoc(doc(controller.db, SEGMENT_TREE, segment_tree_id), {
        root_segment_id: rootSegmentIds,
        master_data_ids: updatedMasterDataIds,
        updated_at: serverTimestamp(),
      });

      const listSegmentTrees: ListSegmentTreesType[] = await getSegmentTree(controller);
      state = controller.getState();
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          listSegments,
          listSegmentTrees,
          loading: false,
        },
      });
    })
    .catch((error) => {
      console.error("Error writing document: ", error);
      state = controller.getState();
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          loading: false,
        },
      });
    });
};

const AddContent: Handler = async (controller, params) => {
  let state = controller.getState();
  // let organTips = state.SegmentTargetSequence?.organTips ?? []
  if (params.type === POST) {
    let posts = state.SegmentTargetSequence?.posts ?? [];
    let append = [...posts];

    const collectionRef = collection(controller.db, POST);
    // Generate "locally" a new document for the given collection reference
    const docRef = doc(collectionRef);

    // Get the new document Id
    const documentUuid = docRef.id;
    append.unshift({ id: documentUuid, division_id: state.selectedDivision.id });
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        posts: append,
      },
    });
  } else if (params.type === ORGAN_TIPS) {
    let organTips = state.SegmentTargetSequence?.organTips ?? [];
    let append = [...organTips];

    const collectionRef = collection(controller.db, ORGAN_TIPS);
    // Generate "locally" a new document for the given collection reference
    const docRef = doc(collectionRef);
    // Get the new document Id
    const documentUuid = docRef.id;
    append.unshift({ id: documentUuid, division_id: state.selectedDivision.id });
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        organTips: append,
      },
    });
  }
};

const findMediaTagsAndText = (htmlString: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  const images = Array.from(doc.querySelectorAll("img"));
  const videos = Array.from(doc.querySelectorAll("iframe"));

  // Extract all text content
  const textContent = doc.body.textContent || doc.body.innerText || "";

  return {
    text: textContent.trim(),
    images: images.map((img) => img.src),
    videos: videos.map((video) => video.src),
  };
};
const SelectSegment: Handler = async (controller, params) => {
  let state = controller.getState();
  // get attached_posts
  // get attached_tips
  let currentSegment = state.SegmentTargetSequence?.listSegments?.find((i) => i.id === params.id);

  let [posts, organTips] = await getContentsRelated(controller.db, currentSegment);

  console.log("selectSegment posts: ", posts);

  console.log("selectSegment organTips: ", organTips);

  console.log("selectSegment state.SegmentTargetSequence: ", state.SegmentTargetSequence);
  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      selectedSegmentId: params.id,
      organTips,
      posts,
    },
  });
};

const UpdateContents: Handler = async (controller, params) => {
  let state = controller.getState();
  console.log("UpdateContents: params: ", params);

  let ret: any;
  if (params.id) {
    if (params.type === POST) {
      let posts: any[] = state.SegmentTargetSequence?.posts || [];
      let idx = posts.findIndex((i) => i.id === params.id);
      if (idx !== -1) {
        if ("content" in params) {
          posts[idx] = { ...posts[idx], content: params.content };
        }
        if ("organTags" in params) {
          posts[idx] = { ...posts[idx], organ_tags: params.organTags };
        }
        if ("files" in params && "info" in params) {
          // Upload file

          console.log("UpdateContents params.files?.[0]: ", params.files?.[0]);
          // upload to storage
          ret = await uploadFile(controller, {
            file: params.files?.[0],
            fileName: params.files?.[0]?.name,
            bucketName: MEHEALTH_POST_GS,
            key: 1,
            idx: 0,
            id: params.id,
          });
        }

        if (params.content) {
          let media = findMediaTagsAndText(params.content);
          console.log("media: ", media);
          let sliceText = media?.text?.slice(0, 175) || "";
          console.log("sliceText: ", sliceText);
          posts[idx] = {
            ...posts[idx],
            previews_text: media?.text,
            shorten_text: sliceText,
            previews_picture: media.images,
            previews_video: media.videos,
          };
        }

        // if ("imageInfo" in params && "state" in params && "index" in params) {

        //   // Image setup
        //   console.log('Image setup : ');
        //   let previews_picture = [...(posts[idx]?.previews_picture ?? [])]
        //   console.log('draftImages: ', previews_picture);
        //   switch (params.state) {
        //     case "create":
        //     case "update":
        //       previews_picture[params.index] = {}
        //       previews_picture[params.index].imageInfo = params.imageInfo;
        //       previews_picture[params.index].targetImgElement = params.targetImgElement;
        //       posts[idx] = {
        //         ...posts[idx],
        //         previews_picture,
        //       };
        //       break;
        //     case "delete":
        //       previews_picture[params.index] = null;
        //       posts[idx] = {
        //         ...posts[idx],
        //         previews_picture,
        //       };
        //       break;
        //     default:
        //       break;
        //   }
        // }
        console.log("UpdateContents state.SegmentTargetSequence: ", state.SegmentTargetSequence);
        console.log("UpdateContents posts: ", posts);
        controller.setState({
          SegmentTargetSequence: {
            ...state.SegmentTargetSequence,
            posts: [...posts],
            loading: false,
          },
        });
      }
    } else if (params.type === ORGAN_TIPS) {
      let organTips: any[] = state.SegmentTargetSequence?.organTips || [];
      let idx = organTips.findIndex((i) => i.id === params.id);
      if (idx !== -1) {
        if ("organ" in params) {
          organTips[idx] = { ...organTips[idx], organ: params.organ };
        }
        if ("content" in params) {
          organTips[idx] = { ...organTips[idx], content: params.content };
        }

        if ("suggestionLabs" in params) {
          organTips[idx] = { ...organTips[idx], suggestion_labs: params.suggestionLabs };
        }
        console.log("UpdateContents state.SegmentTargetSequence: ", state.SegmentTargetSequence);
        console.log("UpdateContents organTips: ", organTips);
        controller.setState({
          SegmentTargetSequence: {
            ...state.SegmentTargetSequence,
            organTips: [...organTips],
            loading: false,
          },
        });
      }
    }
  }

  return ret;
};

const SaveContent: Handler = async (controller, params) => {
  controller.setState((prev) => ({
    SegmentTargetSequence: {
      ...prev.SegmentTargetSequence,
      idxSaveLoading: params.id,
    },
  }));
  let state = controller.getState();

  // get attached_posts
  // get attached_tips
  let currentSegment = state.SegmentTargetSequence?.listSegments?.find(
    (i) => i.id === state.SegmentTargetSequence?.selectedSegmentId,
  );
  console.log("SaveContent params: ", params);
  console.log("SaveContent state.SegmentTargetSequence: ", state.SegmentTargetSequence);
  let attached_posts = currentSegment?.data?.attached_posts ?? [];
  let attached_organTips = currentSegment?.data?.attached_organTips ?? [];
  // loop get Tips and post

  if (params.type === POST) {
    // Update

    // ONSnapshot
    // const unsubPost = onSnapshot(doc(controller.db, POST, params.id), (snapshot) => {
    //   console.log('SaveContent unsubPost snapshot: ', snapshot);
    //   if (!snapshot.metadata.hasPendingWrites) {
    //     console.log("SaveContent unsubPost onSnapshot Current data: ", snapshot.data());
    //   }
    // });

    let previewPost = state.SegmentTargetSequence?.posts?.find((i) => i.id === params.id);
    console.log("SaveContent previewPost: ", previewPost);

    // post
    if (attached_posts.some((id: string) => id === params.id)) {
      // Inject previews

      /************************************
       *
       *  update POST
       *
       ************************************/

      console.log("SaveContent update POST ");

      await updateDoc(doc(controller.db, POST, params.id), {
        content: params.content,
        organ_tags: params.organTags,
        // division_id: state.selectedDivision?.id,
        ...(previewPost?.previews_text && { previews_text: previewPost.previews_text }),
        ...(previewPost?.previews_picture && { previews_picture: previewPost.previews_picture }),
        ...(previewPost?.previews_video && { previews_video: previewPost.previews_video }),
        updated_at: serverTimestamp(),
        isEdit: true,
        updated_by: { id: state.django?.user.id, name: state.django?.user.full_name },
        // published_at: deleteField(),
      });
    } else {
      /************************************
       *
       *  create POST
       *
       ************************************/

      console.log("SaveContent create POST  ");
      await updateDoc(doc(controller.db, SEGMENT, state.SegmentTargetSequence?.selectedSegmentId), {
        attached_posts: [params.id, ...attached_posts],
        updated_at: serverTimestamp(),
        // published_at: deleteField(),
      });

      await setDoc(doc(controller.db, POST, params.id), {
        id: params.id,
        isEdit: true,
        is_active: true,
        content: params.content,
        division_id: state.selectedDivision?.id,
        ...(previewPost?.previews_text && { previews_text: previewPost.previews_text }),
        ...(previewPost?.previews_picture && { previews_picture: previewPost.previews_picture }),
        ...(previewPost?.previews_video && { previews_video: previewPost.previews_video }),
        updated_at: serverTimestamp(),
        created_at: serverTimestamp(),
        organ_tags: params.organTags,
        // is_latest_version: false,
        status: "draft",
        version: 1,
        author_id: Number(state.userId),
        content_storage: {
          bucket_path: null,
          content_url: null,
          content_size: null,
          content_hash: null,
        },
        updated_by: { id: state.django?.user.id, name: state.django?.user.full_name },
      });
    }

    console.log("previewPost.previews_text: ", previewPost.previews_text);
  } else if (params.type === ORGAN_TIPS) {
    // const unsubOrganTips = onSnapshot(doc(controller.db, ORGAN_TIPS, params.id), (snapshot) => {
    //   console.log('SaveContent unsubOrganTips snapshot: ', snapshot);
    //   if (!snapshot.metadata.hasPendingWrites) {
    //     console.log("SaveContent unsubOrganTips onSnapshot Current data: ", snapshot.data());
    //   }
    // });

    let previewOrganTips = state.SegmentTargetSequence?.organTips?.find((i) => i.id === params.id);
    console.log("previewOrganTips: ", previewOrganTips);

    // organTips
    if (attached_organTips.some((id: string) => id === params.id)) {
      /************************************
       *
       *  update Organ Tips
       *
       ************************************/
      console.log("SaveContent update Organ Tips");
      await updateDoc(doc(controller.db, ORGAN_TIPS, params.id), {
        isEdit: true,
        content: params.content,
        // division_id: state.selectedDivision?.id,
        organ: params.organ,
        ...(previewOrganTips?.previews_text && { previews_text: previewOrganTips.previews_text }),
        ...(previewOrganTips?.previews_picture && {
          previews_picture: previewOrganTips.previews_picture,
        }),
        ...(previewOrganTips?.previews_video && {
          previews_video: previewOrganTips.previews_video,
        }),
        suggestion_labs: params.suggestionLabs,
        updated_at: serverTimestamp(),
        updated_by: { id: state.django?.user.id, name: state.django?.user.full_name },
        // published_at: deleteField(),
      });
    } else {
      /************************************
       *
       *  create Organ Tips
       *
       ************************************/

      console.log(
        "SaveContent create Organ Tips state.SegmentTargetSequence?.selectedSegmentId:",
        state.SegmentTargetSequence?.selectedSegmentId,
      );
      console.log("SaveContent create Organ Tips params.idd:", params.id);
      await updateDoc(doc(controller.db, SEGMENT, state.SegmentTargetSequence?.selectedSegmentId), {
        attached_organTips: [params.id, ...attached_organTips],
      });

      await setDoc(doc(controller.db, ORGAN_TIPS, params.id), {
        id: params.id,
        isEdit: true,
        is_active: true,
        content: params.content,
        division_id: state.selectedDivision?.id,
        organ: params.organ,
        suggestion_labs: params.suggestionLabs || [],
        ...(previewOrganTips?.previews_text && { previews_text: previewOrganTips.previews_text }),
        ...(previewOrganTips?.previews_picture && {
          previews_picture: previewOrganTips.previews_picture,
        }),
        ...(previewOrganTips?.previews_video && {
          previews_video: previewOrganTips.previews_video,
        }),
        updated_at: serverTimestamp(),
        created_at: serverTimestamp(),
        // is_latest_version: false,
        status: "draft",
        version: 1,
        author_id: Number(state.userId),
        content_storage: {
          bucket_path: null,
          content_url: null,
          content_size: null,
          content_hash: null,
        },
        updated_by: { id: state.django?.user.id, name: state.django?.user.full_name },
      });
    }
  }

  setTimeout(async () => {
    const listSegments: SegmentItem[] = await getSegmentFromTreeId(
      controller.db,
      state.SegmentTargetSequence?.selectedSegmentTreeId,
    );
    console.log("SaveContent listSegments: ", listSegments);

    let [posts, organTips] = await getContentsRelated(
      controller.db,
      listSegments?.find((i: any) => i.id === state.SegmentTargetSequence?.selectedSegmentId),
    );
    console.log("posts, organTips: ", posts, organTips);
    console.log("SaveContent state.SegmentTargetSequence: ", state.SegmentTargetSequence);

    state = controller.getState();
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        listSegments: listSegments,
        posts,
        organTips,
        idxSaveLoading: "",
      },
    });
  }, 5000);
};

const DeleteContent: Handler = async (controller, params) => {
  let state = controller.getState();

  // get attached_posts
  // get attached_tips
  let currentSegment = state.SegmentTargetSequence?.listSegments?.find(
    (i) => i.id === state.SegmentTargetSequence?.selectedSegmentId,
  );
  // console.log('DeleteContent currentSegment: ', currentSegment);
  // console.log("DeleteContent params: ", params);
  // console.log("DeleteContent state.SegmentTargetSequence: ", state.SegmentTargetSequence);
  let attached_posts = currentSegment?.data?.attached_posts ?? [];
  let attached_organTips = currentSegment?.data?.attached_organTips ?? [];
  // console.log('DeleteContent attached_posts: ', attached_posts);
  // console.log('DeleteContent attached_organTips: ', attached_organTips);

  // Check Is new / not save yet looking in attached_posts
  let isNew = false;
  if (params.type === POST) {
    isNew = !attached_posts?.some((i: string) => i === params.contentId);
  } else if (params.type === ORGAN_TIPS) {
    isNew = !attached_organTips?.some((i: string) => i === params.contentId);
  }

  if (!isNew) {
    let type = params.type === POST ? "posts" : "organ-tips";
    let response = await fetch(
      `${CONFIG.FAST_API}/api/v1/feed/${type}/${params.contentId}/delete`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Token ${controller.apiToken}`,
          "Content-Type": "application/json",
          accept: "application/json",
        },
        body: JSON.stringify({}),
      },
    );
    console.log("Delete response: ", response);

    state = controller.getState();
    if (response.status !== 200) {
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          loading: false,
        },
      });
      console.warn("Cannot delete! ");
      return;
    }
  }

  if (params.type === POST) {
    // await deleteDoc(doc(controller.db, POST, params.id));
    attached_posts = attached_posts?.filter((id: string) => id !== params.contentId);
    await updateDoc(doc(controller.db, SEGMENT, state.SegmentTargetSequence?.selectedSegmentId), {
      attached_posts,
    });
  } else if (params.type === ORGAN_TIPS) {
    // await deleteDoc(doc(controller.db, ORGAN_TIPS, params.id));
    attached_organTips = attached_organTips.filter((id: string) => id !== params.contentId);
    await updateDoc(doc(controller.db, SEGMENT, state.SegmentTargetSequence?.selectedSegmentId), {
      attached_organTips,
    });
  }

  state = controller.getState();
  const listSegments: SegmentItem[] = await getSegmentFromTreeId(
    controller.db,
    state.SegmentTargetSequence?.selectedSegmentTreeId,
  );
  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      listSegments: listSegments,
      ...(params.type === POST && {
        posts: state.SegmentTargetSequence.posts?.filter((data) =>
          attached_posts.includes(data.id),
        ),
      }),
      ...(params.type === ORGAN_TIPS && {
        organTips: state.SegmentTargetSequence.organTips?.filter((data) =>
          attached_organTips.includes(data.id),
        ),
      }),
      loading: false,
    },
  });
};

const Publish: Handler = async (controller, params) => {
  controller.setState((prev) => ({
    SegmentTargetSequence: {
      ...prev.SegmentTargetSequence,
      idxPublishLoading: params.contentId,
    },
  }));

  let type = params.type === POST ? "posts" : "organ-tips";
  let response = await fetch(`${CONFIG.FAST_API}/api/v1/feed/${type}/${params.contentId}/publish`, {
    method: "POST",
    headers: {
      Authorization: `Token ${controller.apiToken}`,
      "Content-Type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify({}),
  });

  console.log("Publish response: ", response);

  let state = controller.getState();
  if (response.status === 200) {
    let typeName = params.type === POST ? "posts" : "organTips";
    console.log("Publish typeName: ", typeName);
    let typeCollection = params.type === POST ? POST : ORGAN_TIPS;
    console.log("Publish typeCollection: ", typeCollection);
    // let version = state.SegmentTargetSequence?.[typeName]?.find( (i: any) => i.id === params.contentId)?.version || 1
    // console.log('Publish state.SegmentTargetSequence?.[typeName]: ', state.SegmentTargetSequence?.[typeName]);
    // console.log('Publish version: ', version);
    await updateDoc(doc(controller.db, typeCollection, params.contentId), {
      version: increment(1),
      published_version: params.publishedVersion,
      isEdit: false,
    });

    setTimeout(async () => {
      state = controller.getState();
      let currentSegment = state.SegmentTargetSequence?.listSegments?.find(
        (i) => i.id === state.SegmentTargetSequence?.selectedSegmentId,
      );
      let [posts, organTips] = await getContentsRelated(controller.db, currentSegment);
      console.log("Publish [posts, organTips]: ", [posts, organTips]);
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          posts,
          organTips,
          idxPublishLoading: "",
        },
      });
    }, 5000);
  } else {
    state = controller.getState();
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        idxPublishLoading: "",
      },
    });
  }
};
const UnPublish: Handler = async (controller, params) => {
  controller.setState((prev) => ({
    SegmentTargetSequence: {
      ...prev.SegmentTargetSequence,
      idxUnpublishLoading: params.contentId,
    },
  }));

  let type = params.type === POST ? "posts" : "organ-tips";
  let response = await fetch(
    `${CONFIG.FAST_API}/api/v1/feed/${type}/${params.contentId}/unpublish`,
    {
      method: "POST",
      headers: {
        Authorization: `Token ${controller.apiToken}`,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({}),
    },
  );

  console.log("UnPublish response: ", response);

  let state = controller.getState();
  if (response.status === 200) {
    let typeName = params.type === POST ? "posts" : "organTips";
    console.log("UnPublish typeName: ", typeName);
    let typeCollection = params.type === POST ? POST : ORGAN_TIPS;
    console.log("UnPublish typeCollection: ", typeCollection);
    // let version = state.SegmentTargetSequence?.[typeName]?.find( (i: any) => i.id === params.contentId)?.version || 1
    // console.log('Publish state.SegmentTargetSequence?.[typeName]: ', state.SegmentTargetSequence?.[typeName]);
    // console.log('Publish version: ', version);
    await updateDoc(doc(controller.db, typeCollection, params.contentId), {
      published_version: deleteField(),
      isEdit: false,
    });

    setTimeout(async () => {
      state = controller.getState();
      let currentSegment = state.SegmentTargetSequence?.listSegments?.find(
        (i) => i.id === state.SegmentTargetSequence?.selectedSegmentId,
      );
      let [posts, organTips] = await getContentsRelated(controller.db, currentSegment);
      console.log("UnPublish [posts, organTips]: ", [posts, organTips]);
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          posts,
          organTips,
          idxUnpublishLoading: "",
        },
      });
    }, 5000);
  } else {
    state = controller.getState();
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        idxUnpublishLoading: "",
      },
    });
  }
};

const GetPublicContents: Handler = async (controller, params) => {
  controller.setState((prev) => {
    return { SegmentTargetSequence: { ...prev.SegmentTargetSequence, publishJson: null } };
  });

  const firebaseApp = getApp();
  const storage = getStorage(firebaseApp, MEDICAL_REPORT_GS);
  const type = params.type === POST ? "posts" : "tips";
  console.log("GetPublishContents: ", `${type}/published/${params.id}/v${params.version}.json`);
  const starsRef = ref(storage, `${type}/published/${params.id}/v${params.version}.json`);
  getDownloadURL(starsRef)
    .then((url) => {
      // `url` is the download URL for 'images/stars.jpg'

      // This can be downloaded directly:
      const xhr = new XMLHttpRequest();
      xhr.responseType = "blob";
      xhr.onload = (event) => {
        xhr.response?.text()?.then((text: string) => {
          console.log("text", text);
          let publishJson = JSON.parse(text);
          controller.setState((prev) => {
            return {
              SegmentTargetSequence: { ...prev.SegmentTargetSequence, publishJson: publishJson },
            };
          });
        });
      };
      xhr.open("GET", url);
      xhr.send();
    })
    .catch((error) => {
      // A full list of error codes is available at
      // https://firebase.google.com/docs/storage/web/handle-errors
      switch (error.code) {
        case "storage/object-not-found":
          // File doesn't exist
          console.log("File doesn't exist");
          break;
        case "storage/unauthorized":
          // User doesn't have permission to access the object
          console.log("User doesn't have permission to access the object");
          break;
        case "storage/canceled":
          // User canceled the upload
          console.log("User canceled the upload");
          break;

        case "storage/unknown":
          // Unknown error occurred, inspect the server response
          console.log("Unknown error occurred, inspect the server response");
          break;
      }
    });
};

const SaveOrganTips: Handler = async (controller, params) => {
  let state = controller.getState();
  // get attached_posts
  // get attached_tips
  // let currentSegment = state.SegmentTargetSequence?.listSegments?.find(i => i.id === state.SegmentTargetSequence?.selectedSegmentId)
  // let attached_posts = currentSegment?.data?.attached_posts ?? []
  // let attached_tips = currentSegment?.data?.attached_tips ?? []
  // // loop get Tips and post

  // const postsRef = collection(controller.db, POST);
  // const organTipsRef = collection(controller.db, ORGAN_TIPS);

  // // Create a query against the collection.
  // const qPosts = query(postsRef, where("id", "in" , attached_posts));
  // const qOrganTips = query(organTipsRef, where("id", "in" , attached_tips));

  // let posts: any[] = []
  // let organTips: any[] = []

  // const qPostsSnapshot = await getDocs(qPosts);
  // qPostsSnapshot.forEach((doc) => {
  //   // doc.data() is never undefined for query doc snapshots
  //   posts.push(doc)
  //   console.log(doc.id, " => ", doc.data());
  // });
  // const qOrganTipsSnapshot = await getDocs(qOrganTips);
  // qOrganTipsSnapshot.forEach((doc) => {
  //   // doc.data() is never undefined for query doc snapshots
  //   console.log(doc.id, " => ", doc.data());
  //   organTips.push(doc)
  // });

  console.log("selectSegment state.SegmentTargetSequence: ", state.SegmentTargetSequence);
  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      selectedSegmentId: params.id,
      organTips,
      posts,
    },
  });
};

// Utils
const uploadFile: Handler = async (
  controller,
  params: {
    file: File;
    fileName?: string;
    bucketName: `gs://${string}`;
    key?: string;
    idx?: number;
    id: string;
  },
): Promise<{ key: string; url: string }> => {
  const fileName = `${params.idx}_${params.file.name}`;
  const objectPath = `images/${params.id}/${fileName}`; // no leading slash for Storage paths

  // You can pass a full gs:// URL directly to ref()
  const fileRef = ref(controller.storage, `${params.bucketName}/${objectPath}`);

  const metadata = params.file?.type ? { contentType: params.file.type } : undefined;
  const uploadTask = uploadBytesResumable(fileRef, params.file, metadata);

  return new Promise<{ key: string; url: string }>((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      // progress callback (optional)
      (snapshot) => {
        // e.g., params.onProgress?.(snapshot.bytesTransferred / snapshot.totalBytes);
      },
      // error
      (error) => {
        console.error(error);
        reject(error);
      },
      // complete
      async () => {
        try {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          resolve({ key: params.key || "", url });
        } catch (e) {
          reject(e);
        }
      },
    );
  });
};

const uploadFileRuleTemplatesCSV: Handler = async (
  controller,
  params: {
    file: File;
  },
) => {
  const formData = new FormData();
  formData.append("file", params.file);

  try {
    let response = await fetch(`${CONFIG.FAST_API}/api/v1/feed/rule-templates/upload-csv`, {
      method: "POST",
      headers: {
        Authorization: `Token ${controller.apiToken}`,
        accept: "application/json",
      },
      body: formData,
    });

    if (response.status === 200) {
      const result = await response.json();
      console.log("Upload FileRuleTemplates Success:", result);
      return result;
    } else {
      const errorText = await response.text();
      console.error("Upload FileRuleTemplates Failed:", response.status, errorText);
      return null;
    }
  } catch (error) {
    console.error("Upload FileRuleTemplates error:", error);
    return null;
  }
};

// --- Main Handler ---
const ImplementRuleFile: Handler = async (controller, params) => {
  let currentState = controller.getState();
  const sequence = currentState.SegmentTargetSequence;

  if (!params.ruleFile || !sequence)
    return controller.setState({
      SegmentTargetSequence: {
        ...sequence,
        error: "Rule template CSV file not found.",
      },
    });

  controller.setState({
    SegmentTargetSequence: {
      ...sequence,
      loadingStatus: { ...sequence.loadingStatus, [params.card]: true },
    },
  });

  // อัพโหลด file ไปให้หลังบ้านสร้าง SEGMWENT_RULE_TEMPLATES มาให้
  const res = await uploadFileRuleTemplatesCSV(controller, { file: params.ruleFile });

  if (!res) {
    return controller.setState({
      SegmentTargetSequence: {
        ...sequence,
        error: "Upload FileRuleTemplates Failed",
      },
    });
  }

  // 1. Fetch data
  const listSegmentTrees = await getSegmentTree(controller);
  const rawTemplates = await getRawDataRuleTemplates(controller);

  // for test
  // const rawTemplatesT = await getRawDataRuleTemplates(controller);
  // const rawTemplates = rawTemplatesT.filter((item) =>
  //   ["LDL", "PSA", "HDL", "FBS", "ALT"].includes(item.data.lab_names?.[0] || ""),
  // );

  if (!rawTemplates || rawTemplates.length === 0) {
    console.warn("No raw data templates found from API.");
    currentState = controller.getState();
    const currentSeq = currentState.SegmentTargetSequence;
    if (currentSeq) {
      controller.setState({
        SegmentTargetSequence: {
          ...currentSeq,
          error: "No raw data templates found.",
          loadingStatus: { ...currentSeq.loadingStatus, [params.card]: false },
        },
      });
    }
    return;
  }

  const queryRuleTemplates = await getDocs(collection(controller.db, RULE_TEMPLATES));
  const ruleTemplates: RuleTemplatesType[] = [];
  queryRuleTemplates.forEach((doc: any) => {
    ruleTemplates.push({ id: doc.id, data: doc.data() });
  });

  // 2. Update Age Range
  await updateAgeRangeTemplate(controller, ruleTemplates, rawTemplates);

  // 3. Group and Parse
  const grouped = groupRawTemplates(rawTemplates);
  const parsedRuleTemplates = buildParsedRuleTemplates(grouped, currentState.userId || "1");

  // 4. Reconcile Templates
  await reconcileRuleTemplatesWithFirebase(controller, ruleTemplates, parsedRuleTemplates);

  // 5. Build and Persist Segments
  const importedSegments = await buildAndPersistSegments(
    controller,
    currentState,
    listSegmentTrees,
    parsedRuleTemplates,
  );

  // 6. Fetch updated lists
  const updatedListSegmentTrees = await getSegmentTree(controller);
  const updatedQueryRuleTemplates = await getDocs(collection(controller.db, RULE_TEMPLATES));
  const updatedRuleTemplates: RuleTemplatesType[] = [];
  updatedQueryRuleTemplates.forEach((doc: any) => {
    updatedRuleTemplates.push({ id: doc.id, data: doc.data() });
  });

  // 7. Update Local State
  currentState = controller.getState();
  const finalSeq = currentState.SegmentTargetSequence;
  if (finalSeq) {
    controller.setState({
      SegmentTargetSequence: {
        ...finalSeq,
        ruleTemplates: updatedRuleTemplates,
        listSegmentTrees: updatedListSegmentTrees,
        selectedSegmentTreeId: undefined,
        loadingStatus: { ...finalSeq.loadingStatus, [params.card]: false },
      },
    });
  }
};

// --- Helper Functions for ImplementRuleFile ---

const updateAgeRangeTemplate = async (
  controller: any,
  ruleTemplates: RuleTemplatesType[],
  rawTemplates: any[],
) => {
  const ageRangeTemplate = ruleTemplates.find(
    (t) => t.data.name === "Age Range" || t.data.field === "age",
  );
  if (ageRangeTemplate) {
    const existingOptions = ageRangeTemplate.data.template?.condition_options || [];
    const uniqueAges = Array.from(
      new Set(rawTemplates.map((t) => t.data.age).filter((a) => a && a.toLowerCase() !== "all")),
    );

    let updated = false;
    uniqueAges.forEach((ageStr) => {
      const parsedOption = parseAgeRange(ageStr as string);
      if (
        !existingOptions.some(
          (opt: any) => opt.id === parsedOption.id || opt.text === parsedOption.text,
        )
      ) {
        existingOptions.push(parsedOption);
        updated = true;
      }
    });

    if (updated) {
      if (!ageRangeTemplate.data.template) ageRangeTemplate.data.template = {} as any;
      ageRangeTemplate.data.template.condition_options = existingOptions;

      await UpdateRuleTemplate(controller, {
        id: ageRangeTemplate.id,
        data: ageRangeTemplate.data,
      });
    }
  }
};

const groupRawTemplates = (rawTemplates: any[]) => {
  const grouped: Record<string, any[]> = {};
  const groupedMasterDataIds: Record<string, string[]> = {};

  rawTemplates.forEach((item) => {
    const data = item.data;
    if (!data) return;

    const labNameKey = (data.lab_names || []).join(", ") || data.name || "Unknown Lab";
    if (!grouped[labNameKey]) grouped[labNameKey] = [];
    if (!groupedMasterDataIds[labNameKey]) groupedMasterDataIds[labNameKey] = [];

    // Collect master_data_ids (unique)
    const ids: string[] = data.master_data_ids || [];
    ids.forEach((id: string) => {
      if (id && !groupedMasterDataIds[labNameKey].includes(id)) {
        groupedMasterDataIds[labNameKey].push(id);
      }
    });

    grouped[labNameKey].push({
      "Tag Assign": data.tag_assign || "",
      "Condition (Logic)": data.condition_logic || "",
      "Tag Group": data.tag_group || "",
      "Target Organ": (data.target_organs || []).map((item: any) => item.toLowerCase()).join(", "),
      "Personalized Advice": data.personalized_advice || "",
      Sex: data.sex || "All",
      Age: data.age || "All",
      template: data.template,
    });
  });

  // Attach master_data_ids array to each group item (first slot only, for passing to buildParsedRuleTemplates)
  (grouped as any).__masterDataIds__ = groupedMasterDataIds;
  return grouped;
};

const buildParsedRuleTemplates = (grouped: Record<string, any[]>, userId: string) => {
  const parsedRuleTemplates: RuleTemplatesType[] = [];
  const masterDataIdsMap: Record<string, string[]> = (grouped as any).__masterDataIds__ || {};

  Object.keys(grouped)
    .filter((k) => k !== "__masterDataIds__")
    .forEach((labName) => {
      const rows = grouped[labName];

      const condition_options = rows.map((row: any, index: number) => {
        const tagAssign: string = (row["Tag Assign"] || "").trim();
        const conditionStr: string = (row["Condition (Logic)"] || "").trim();

        const id = tagAssign
          ? tagAssign
            .replace(/[^A-Za-z0-9]/g, "_")
            .replace(/_+/g, "_")
            .substring(0, 20)
          : `opt_${index}`;

        const parsed = parseLabCondition(conditionStr);

        return {
          id,
          text: tagAssign,
          tag_group: (row["Tag Group"] || "").trim(),
          target_organ: (row["Target Organ"] || "").trim(),
          personalized_advice: (row["Personalized Advice"] || "").trim(),
          sex: (row["Sex"] || "All").trim(),
          age: (row["Age"] || "All").trim(),
          template: row.template,
          ...parsed,
        };
      });

      const master_data_ids: string[] = masterDataIdsMap[labName] || [];

      const templateData: Partial<DataRuleTemplatesType> = {
        created_at: Timestamp.now(),
        created_by: Number(userId) || 1,
        usage_count: 0,
        rule_type: "labResult",
        name: labName,
        last_used: null as any,
        template: {
          rule_type: "labResult",
          value_type: "number",
          validation: { max: 0, min: 0 },
          condition_options,
        },
        is_active: true,
        ...(master_data_ids.length > 0 && { master_data_ids }),
      };

      parsedRuleTemplates.push({ id: "", data: templateData });
    });
  return parsedRuleTemplates;
};

const reconcileRuleTemplatesWithFirebase = async (
  controller: any,
  ruleTemplates: RuleTemplatesType[],
  parsedRuleTemplates: RuleTemplatesType[],
) => {
  for (const parsedTemplate of parsedRuleTemplates) {
    const existingTemplate = ruleTemplates.find((t) => t.data.name === parsedTemplate.data.name);

    if (existingTemplate) {
      parsedTemplate.id = existingTemplate.id;
      const existingOptions = existingTemplate.data.template?.condition_options || [];
      const newOptions = parsedTemplate.data.template?.condition_options || [];

      const normalizeItem = (item: any) => {
        const sorted: any = {};
        Object.keys(item)
          .sort()
          .forEach((k) => (sorted[k] = item[k]));
        return sorted;
      };

      const normalizeArray = (arr: any[]) =>
        arr.map(normalizeItem).sort((a, b) => (a.id || "").localeCompare(b.id || ""));

      const isOptionsSame =
        JSON.stringify(normalizeArray(existingOptions)) ===
        JSON.stringify(normalizeArray(newOptions));

      // Merge master_data_ids (unique) — รวม ID ที่มีอยู่เดิมกับ ID ใหม่ที่เข้ามา
      const incomingMasterDataIds: string[] = parsedTemplate.data.master_data_ids ?? [];
      const existingMasterDataIds: string[] = existingTemplate.data.master_data_ids ?? [];
      const mergedMasterDataIds: string[] = Array.from(
        new Set([...existingMasterDataIds, ...incomingMasterDataIds]),
      );
      const isMasterDataIdsSame =
        JSON.stringify([...existingMasterDataIds].sort()) ===
        JSON.stringify([...mergedMasterDataIds].sort());

      if (!isOptionsSame || !isMasterDataIdsSame) {
        parsedTemplate.data = {
          ...existingTemplate.data,
          template: {
            ...existingTemplate.data.template,
            condition_options: newOptions,
          },
          ...(mergedMasterDataIds.length > 0 && { master_data_ids: mergedMasterDataIds }),
          updated_at: Timestamp.now(),
        } as any;

        await setDoc(doc(controller.db, RULE_TEMPLATES, parsedTemplate.id), parsedTemplate.data, {
          merge: true,
        });
      } else {
        parsedTemplate.data = existingTemplate.data;
      }
    } else {
      const newDocRef = doc(collection(controller.db, RULE_TEMPLATES));
      parsedTemplate.id = newDocRef.id;
      parsedTemplate.data.created_at = Timestamp.now();
      parsedTemplate.data.updated_at = Timestamp.now();

      await setDoc(newDocRef, parsedTemplate.data);
    }
  }
};

const upsertOrganTipsForSegment = async (
  controller: any,
  state: any,
  segId: string,
  personalized_advice: string,
  target_organs: string[],
) => {
  if (!target_organs || target_organs.length === 0) return;

  // Fetch current segment to read attached_organTips
  const segSnap = await getDoc(doc(controller.db, SEGMENT, segId));
  const existingAttached: string[] = segSnap.exists()
    ? (segSnap.data()?.attached_organTips ?? [])
    : [];

  const newAttached = [...existingAttached];

  for (const organ of target_organs) {
    if (!organ) continue;

    // Try to find an existing organTip for this organ already attached to segment
    let existingOrganTipId: string | null = null;
    if (existingAttached.length > 0) {
      const snaps = await Promise.all(
        existingAttached.map((id) => getDoc(doc(controller.db, ORGAN_TIPS, id))),
      );
      const match = snaps.find((s) => s.exists() && s.data()?.organ === organ);
      if (match) existingOrganTipId = match.id;
    }

    if (existingOrganTipId) {
      // Update existing OrganTip
      await updateDoc(doc(controller.db, ORGAN_TIPS, existingOrganTipId), {
        content: personalized_advice,
        organ,
        updated_at: serverTimestamp(),
        // Add missing fields just in case it was an older auto-generated tip
        content_storage: {
          bucket_path: null,
          content_url: null,
          content_size: null,
          content_hash: null,
        },
        division_id: state.selectedDivision?.id || null,
        author_id: Number(state.userId) || null,
        updated_by: {
          id: state.django?.user?.id || null,
          name: state.django?.user?.full_name || null,
        },
      });
    } else {
      // Create new OrganTip
      const newOrganTipRef = doc(collection(controller.db, ORGAN_TIPS));
      await setDoc(newOrganTipRef, {
        id: newOrganTipRef.id,
        isEdit: true,
        is_active: true,
        content: personalized_advice,
        organ,
        suggestion_labs: [],
        status: "draft",
        version: 1,
        division_id: state.selectedDivision?.id || null,
        author_id: Number(state.userId) || null,
        content_storage: {
          bucket_path: null,
          content_url: null,
          content_size: null,
          content_hash: null,
        },
        updated_by: {
          id: state.django?.user?.id || null,
          name: state.django?.user?.full_name || null,
        },
        created_at: serverTimestamp(),
        updated_at: serverTimestamp(),
      });

      // Link to segment
      newAttached.push(newOrganTipRef.id);
    }
  }

  if (newAttached.length !== existingAttached.length) {
    await updateDoc(doc(controller.db, SEGMENT, segId), {
      attached_organTips: newAttached,
    });
  }
};

const buildAndPersistSegments = async (
  controller: any,
  state: any,
  listSegmentTrees: ListSegmentTreesType[],
  parsedRuleTemplates: RuleTemplatesType[],
) => {
  // ลำดับการสร้าง เพส -> อายุ -> lab
  const importedSegmentTrees: ListSegmentTreesType[] = [];
  const importedSegments: SegmentItem[] = [];

  const isEqualSegment = (data1: any, data2: any) => {
    const fields = [
      "name",
      "description",
      "rule",
      "child_segment_ids",
      "parent_segment_id",
      "seq",
      "segment_tree_id",
    ];
    return fields.every((f) => JSON.stringify(data1[f]) === JSON.stringify(data2[f]));
  };

  for (const ruleTemplate of parsedRuleTemplates) {
    const treeName = ruleTemplate.data.name ?? "Unknown Lab";
    const existingTree = listSegmentTrees.find((t) => t.data.name === treeName);
    const treeId = existingTree ? existingTree.id : doc(collection(controller.db, SEGMENT_TREE)).id;

    let existingTreeSegments: SegmentItem[] = [];
    if (existingTree) {
      existingTreeSegments = await getSegmentFromTreeId(controller.db, treeId);
    }

    const conditionOptions: any[] = ruleTemplate.data.template?.condition_options ?? [];
    const currentTreeSegments: SegmentItem[] = [];
    const sexGroups: Record<string, any[]> = {};

    conditionOptions.forEach((opt) => {
      const sex = opt.sex || "All";
      if (!sexGroups[sex]) sexGroups[sex] = [];
      sexGroups[sex].push(opt);
    });

    const finalTreeRoots: string[] = [];

    Object.keys(sexGroups).forEach((sex) => {
      const isSexAll = sex.toLowerCase() === "all";
      let sexSegId = "";

      if (!isSexAll) {
        const existingSex = existingTreeSegments.find(
          (s) =>
            s.data.parent_segment_id === "" &&
            s.data.rule?.field === "sex" &&
            s.data.rule?.value === sex.toLowerCase(),
        );
        sexSegId = existingSex ? existingSex.id : doc(collection(controller.db, SEGMENT)).id;
      }

      const ageGroups: Record<string, any[]> = {};
      sexGroups[sex].forEach((opt) => {
        const age = opt.age || "All";
        if (!ageGroups[age]) ageGroups[age] = [];
        ageGroups[age].push(opt);
      });

      const currentSexChildren: string[] = [];

      Object.keys(ageGroups).forEach((age) => {
        const isAgeAll = age.toLowerCase() === "all";
        let ageSegId = "";
        const sexParentId = isSexAll ? "" : sexSegId;

        if (!isAgeAll) {
          const existingAge = existingTreeSegments.find(
            (s) =>
              s.data.parent_segment_id === sexParentId &&
              s.data.rule?.field === "age" &&
              String(s.data.rule?.value) === String(age),
          );
          ageSegId = existingAge ? existingAge.id : doc(collection(controller.db, SEGMENT)).id;
        }

        const conditionSegIds: string[] = [];
        const condParentId = isAgeAll ? sexParentId : ageSegId;

        ageGroups[age].forEach((opt, idx) => {
          const existingCond = existingTreeSegments.find(
            (s) => s.data.parent_segment_id === condParentId && s.data.name === (opt.text || ""),
          );
          const condSegId = existingCond
            ? existingCond.id
            : doc(collection(controller.db, SEGMENT)).id;
          conditionSegIds.push(condSegId);

          const segmentItem: SegmentItem = {
            id: condSegId,
            data: createSegmentData({
              name: opt.text ?? "",
              description: opt.personalized_advice ?? "",
              seq: idx,
              rule: createRuleData(ruleTemplate.data, opt),
              segment_tree_id: treeId,
              parent_segment_id: condParentId,
              path_from_root: [],
              child_segment_ids: opt.template?.child_segment_ids || [],
              created_by: 1,
              created_at: Timestamp.now(),
              updated_at: Timestamp.now(),
              master_data_ids: ruleTemplate.data.master_data_ids ?? [],
            }) as any,
          };
          currentTreeSegments.push(segmentItem);
        });

        if (isAgeAll) {
          if (isSexAll) finalTreeRoots.push(...conditionSegIds);
          else currentSexChildren.push(...conditionSegIds);
        } else {
          const segmentItem: SegmentItem = {
            id: ageSegId,
            data: createSegmentData({
              name: `${age}`,
              description: `${age}`,
              seq: 0,
              rule: {
                rule_type: "demographic",
                field: "age",
                operator: "==",
                value: age,
              },
              segment_tree_id: treeId,
              parent_segment_id: sexParentId,
              path_from_root: [],
              child_segment_ids: conditionSegIds,
              created_by: 1,
              created_at: Timestamp.now(),
              updated_at: Timestamp.now(),
            }) as any,
          };
          currentTreeSegments.push(segmentItem);

          if (isSexAll) finalTreeRoots.push(ageSegId);
          else currentSexChildren.push(ageSegId);
        }
      });

      if (!isSexAll) {
        const segmentItem: SegmentItem = {
          id: sexSegId,
          data: createSegmentData({
            name: `${sex}`,
            description: `${sex}`,
            seq: 0,
            rule: {
              rule_type: "demographic",
              field: "sex",
              operator: "==",
              value: sex.toLowerCase(),
            },
            segment_tree_id: treeId,
            parent_segment_id: "",
            path_from_root: [],
            child_segment_ids: currentSexChildren,
            created_by: 1,
            created_at: Timestamp.now(),
            updated_at: Timestamp.now(),
          }) as any,
        };
        currentTreeSegments.push(segmentItem);
        finalTreeRoots.push(sexSegId);
      }
    });

    // Collect unique master_data_ids from this ruleTemplate
    const treeMasterDataIds: string[] = Array.from(
      new Set(ruleTemplate.data.master_data_ids ?? []),
    );

    const segmentTreeData: Partial<ListDataType> = {
      created_at: Timestamp.now(),
      updated_at: Timestamp.now(),
      created_by: 1,
      divisionCode: (state as any).selectedDivision?.code ?? "",
      divisionId: (state as any).selectedDivision?.id ?? 0,
      is_active: true,
      name: ruleTemplate.data.name ?? "",
      description: "",
      root_segment_id: finalTreeRoots,
      ...(treeMasterDataIds.length > 0 && { master_data_ids: treeMasterDataIds }),
    };
    importedSegmentTrees.push({ id: treeId, data: segmentTreeData });

    // Compare tree and only update if changed
    if (existingTree) {
      const isTreeEqual = ["name", "root_segment_id", "master_data_ids"].every(
        (f) =>
          JSON.stringify(existingTree.data[f]) ===
          JSON.stringify(segmentTreeData[f as keyof typeof segmentTreeData]),
      );
      if (!isTreeEqual) {
        // Update
        const updateData = { ...segmentTreeData };
        delete updateData.created_at; // Preserve original created_at
        await setDoc(doc(controller.db, SEGMENT_TREE, treeId), updateData, { merge: true });
      }
    } else {
      // Create
      await setDoc(doc(controller.db, SEGMENT_TREE, treeId), segmentTreeData);
    }

    // Compare and update segments
    for (const seg of currentTreeSegments) {
      const existing = existingTreeSegments.find((s) => s.id === seg.id);
      const isConditionSegment = (seg.data as any).rule?.rule_type === "labResult";
      const condOpt = isConditionSegment
        ? (ruleTemplate.data.template?.condition_options ?? []).find(
          (opt: any) => seg.data.name === (opt.text || ""),
        )
        : null;

      const target_organs = getTargetOrgans(condOpt?.target_organ);

      console.log("Debug ~ buildAndPersistSegments ~ target_organs:", target_organs);

      if (!existing) {
        // Create
        await setDoc(doc(controller.db, SEGMENT, seg.id), seg.data);
        // Upsert OrganTips if target_organ exists
        if (isConditionSegment && target_organs.length > 0) {
          await upsertOrganTipsForSegment(
            controller,
            state,
            seg.id,
            condOpt?.personalized_advice ?? "",
            target_organs,
          );
        }
      } else if (!isEqualSegment(existing.data, seg.data)) {
        // Update
        const updateData = { ...seg.data };
        delete updateData.created_at; // Preserve original created_at
        await setDoc(doc(controller.db, SEGMENT, seg.id), updateData, { merge: true });
        // Upsert OrganTips if target_organ exists
        if (isConditionSegment && target_organs.length > 0) {
          await upsertOrganTipsForSegment(
            controller,
            state,
            seg.id,
            condOpt?.personalized_advice ?? "",
            target_organs,
          );
        }
      }
    }

    importedSegments.push(...currentTreeSegments);
  }
  return importedSegments;
};

/**
 * Parses a single condition string from the CSV "Condition (Logic)" column
 *
 * Supported patterns:
 *   - Double inequality range : `100 <= FBS <= 125`, `0.4 <= TSH <= 4.5`
 *   - Dash range              : `100–129`, `300 - 1000`, `5.7 - 6.4`
 *   - Simple comparison       : `HDL >= 40`, `TSH < 0.4`, `>= 10`, `< 200`
 *   - String equality literal : `Positive`, `Negative`, `Reactive`, `Nonreactive`
 *   - "{var} = StringLiteral" : `anti-HCV = Positive`, `HBsAg = Positive`
 *   - Complex AND/OR          : stored as `{ operator: "expression", expression: "..." }`
 */
const parseLabCondition = (conditionStr: string): Record<string, any> => {
  const raw = (conditionStr || "")
    .trim()
    // Normalise em-dash / en-dash / minus to ASCII hyphen
    .replace(/[–—]/g, "-")
    // Normalise unicode inequalities
    .replace(/≥/g, ">=")
    .replace(/≤/g, "<=")
    // Remove commas inside numbers: 1,000 → 1000
    .replace(/(\d),(\d)/g, "$1$2");

  if (!raw) return { operator: "unknown" };

  // Strip trailing unit text (mg/dL, mmHg, pg/mL, ng/mL, …)
  const stripped = raw
    .replace(
      /\s+(mg\/[a-zA-Z]+|mmHg|pg\/mL|ug\/[a-zA-Z]+|ng\/[a-zA-Z]+|mIU\/mL|mm\/hr|mmol\/L|g\/[a-zA-Z]+|fL|%)\s*$/i,
      "",
    )
    .trim();

  // 1. Double-inequality range:  {lo} <= {VAR} <= {hi}  |  {lo} <= {hi}
  const dblIneq =
    stripped.match(/^([\d.]+)\s*<=\s*[\w\s/().-]+\s*<=\s*([\d.]+)$/) ||
    stripped.match(/^([\d.]+)\s*<=\s*([\d.]+)$/);
  if (dblIneq) {
    return { operator: "range", min_value: Number(dblIneq[1]), max_value: Number(dblIneq[2]) };
  }

  // 2. Dash range:  100-129  |  300 - 1000
  const dashRange = stripped.match(/^([\d.]+)\s*-\s*([\d.]+)$/);
  if (dashRange) {
    return { operator: "range", min_value: Number(dashRange[1]), max_value: Number(dashRange[2]) };
  }

  // 3. Complex AND / OR expression (multi-lab)
  if (/\bOR\b|\bAND\b/i.test(raw)) {
    return { operator: "expression", value: raw };
  }

  // 4. Simple comparison:  {VAR} {op} {number}  |  {op} {number}
  const simpleComp = stripped.match(/^(?:[\w\s/().-]+\s*)?(>=|<=|>|<|==?)\s*([\d.]+)\s*$/);
  if (simpleComp) {
    const op = simpleComp[1] === "=" ? "==" : simpleComp[1];
    return { operator: op, value: Number(simpleComp[2]) };
  }

  // 5. "{var} = StringLiteral"  e.g.  "anti-HCV = Positive"
  const varEqStr = stripped.match(/^[\w\s/()-]+=\s*([A-Za-z]\w*)$/);
  if (varEqStr) {
    return { operator: "==", value: varEqStr[1].toLowerCase() };
  }

  // 6. Bare prefix operator with number:  ">190", ">=10"
  const prefixOp = stripped.match(/^(>=|<=|>|<)\s*([\d.]+)$/);
  if (prefixOp) {
    return { operator: prefixOp[1], value: Number(prefixOp[2]) };
  }

  // 7. Pure string literal: Positive, Negative, Reactive, Nonreactive …
  if (/^[A-Za-z]\w*$/.test(stripped)) {
    return { operator: "==", value: stripped.toLowerCase() };
  }

  // 8. Fallback – keep as raw expression
  return { operator: "expression", value: raw };
};

/**
 * Parses age strings (e.g., "อายุ 20-39 ปี", "อายุ 60 ปีขึ้นไป") into structured condition options.
 */
const parseAgeRange = (ageStr: string) => {
  const rawText = ageStr.trim();
  let operator = "==";
  let val: any = 0;
  let min: number | undefined;
  let max: number | undefined;

  // 1. Parsing Phase: Determine the logical intent and extract numbers
  const rangeMatch = rawText.match(/(\d+)\s*[-–]\s*(\d+)/);
  if (rangeMatch) {
    operator = "range";
    min = parseInt(rangeMatch[1]);
    max = parseInt(rangeMatch[2]);
    val = max;
  } else if (rawText.includes("ขึ้นไป") || rawText.includes(">=") || rawText.includes(">")) {
    operator = ">=";
    const m = rawText.match(/(\d+)/);
    val = m ? parseInt(m[0]) : 0;
  } else if (rawText.includes("น้อยกว่า") || rawText.includes("<") || rawText.includes("<=")) {
    operator = "<";
    const m = rawText.match(/(\d+)/);
    val = m ? parseInt(m[0]) : 0;
  } else {
    const m = rawText.match(/(\d+)/);
    if (m) {
      val = parseInt(m[0]);
    } else {
      val = rawText;
    }
  }

  // 2. Formatting Phase: Construct display text based on the detected operator
  let text = "";
  if (operator === "range") {
    text = `อายุ ${min}-${max} ปี`;
  } else if (operator === ">=") {
    text = `อายุ ${val} ปีขึ้นไป`;
  } else if (operator === "<") {
    text = `อายุน้อยกว่า ${val}`;
  } else if (typeof val === "number" && (rawText.startsWith("อายุ") || rawText.endsWith("ปี"))) {
    text = `อายุ ${val} ปี`;
  } else {
    text = `${val}`;
  }

  return {
    id: operator === "range" ? `${min}-${max}Y` : `${val}Y`,
    text,
    operator,
    ...(min !== undefined && { min_value: min }),
    ...(max !== undefined && { max_value: max }),
    ...(operator !== "range" && { value: val }),
  };
};

/**
 * Updates a rule template in Firestore (collection RULE_TEMPLATES)
 */
export const UpdateRuleTemplate: Handler = async (controller, params) => {
  if (!params.id || !params.data) {
    console.error("UpdateRuleTemplate: missing id or data");
    return;
  }

  try {
    const docRef = doc(controller.db, RULE_TEMPLATES, params.id);
    await updateDoc(docRef, {
      ...params.data,
      updated_at: serverTimestamp(),
    });

    // Update local state
    const state = controller.getState();
    const currentTemplates = state.SegmentTargetSequence?.ruleTemplates || [];
    const updatedTemplates = currentTemplates.map((item) =>
      item.id === params.id ? { ...item, data: { ...item.data, ...params.data } } : item,
    );

    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        ruleTemplates: updatedTemplates,
      },
    });
    console.log(`Successfully updated rule template: ${params.id}`);
  } catch (error) {
    console.error("Error updating rule template: ", error);
  }
};

export const createSegmentData = ({
  name,
  description = "",
  seq = 0,
  rule,
  segment_tree_id,
  parent_segment_id = "",
  path_from_root = [],
  created_by = 1,
  child_segment_ids = [],
  created_at,
  updated_at,
  master_data_ids = [],
}: {
  name: string;
  description?: string;
  seq?: number;
  rule: any;
  segment_tree_id: string;
  parent_segment_id?: string;
  path_from_root?: string[];
  created_by?: number;
  child_segment_ids?: string[];
  created_at?: any;
  updated_at?: any;
  master_data_ids?: string[];
}): SegmentData => {
  return {
    name,
    description,
    seq,
    rule,
    child_segment_ids,
    attached_content: [],
    is_active: true,
    segment_tree_id,
    parent_segment_id,
    path_from_root,
    created_by,
    created_at: created_at || serverTimestamp(),
    updated_at: updated_at || serverTimestamp(),
    ...(master_data_ids.length > 0 && { master_data_ids }),
  };
};

export const createRuleData = (ruleTemplate: any, opt: any): SegmentRule => {
  return {
    rule_type: ruleTemplate?.rule_type ?? "labResult",
    operator: opt?.operator ?? "",
    ...(ruleTemplate?.lab_test_master_id && {
      lab_test_master_id: ruleTemplate.lab_test_master_id,
    }),
    ...(ruleTemplate?.field && { field: ruleTemplate.field }),
    ...(opt?.value !== undefined && { value: opt.value }),
    ...(opt?.max_value !== undefined && { max_value: Number(opt.max_value) }),
    ...(opt?.min_value !== undefined && { min_value: Number(opt.min_value) }),
  };
};

export const getTargetOrgans = (targetOrganString: string | string[]): string[] => {
  const VALID_ORGANS = [
    "heart",
    "brain",
    "liver",
    "kidney",
    "lung",
    "stomach",
    "intestine",
    "pancreas",
    "vein",
    "bone",
    "spleen",
    "skin",
    "teeth",
  ];
  const ORGAN_MAPPING: Record<string, string> = {
    cvd: "heart",
    cardiovascular: "heart",
  };

  if (!targetOrganString) return [];

  const organsArray = Array.isArray(targetOrganString)
    ? targetOrganString
    : targetOrganString.split(",");

  return organsArray
    .map((s: string) => {
      let organ = s.trim().toLowerCase();
      return ORGAN_MAPPING[organ] || organ;
    })
    .filter((s: string) => VALID_ORGANS.includes(s));
};
